import { Modal, Button } from 'antd';
import React from 'react';
import { translations } from '../../utils/constants';

const DeleteModal = ({ title, bodyText, isOpen, onCancel, onDelete, language }) => {
    return (
        <Modal
            className='delete-modal'
            title={<div className='modal-header'>{title}</div>}
            open={isOpen}
            onCancel={onCancel}
            footer={[
                <div className='modal-footer' key='footer'>
                    <Button key='cancel' onClick={onCancel} className="cancel-button" >
                        {translations[language]?.cancel}
                    </Button>
                    <Button key='delete' type='primary' onClick={onDelete} className="submit-button">
                        {translations[language]?.deleteheading}
                    </Button>
                </div>
            ]}
        >
            <div className='modal-body'>
                <p>{bodyText}</p>
            </div>
        </Modal>
    );
};

export default DeleteModal;
